import { Box } from "@mui/material"
import { Loading } from "./loading"

export const CenterLoading = () => {
    return (
        <Box display={"flex"} justifyContent={"center"} alignItems={"center"} height={"100vh"} width={"100%"}>
            <Loading source={"CenterLoading"} />
        </Box>
    )
}
